import pool1 from "../images/photoForSliders/waterpool/DSC05871.jpg";
import pool2 from "../images/photoForSliders/waterpool/DSC05827.jpg";
import pool3 from "../images/photoForSliders/waterpool/DSC05800.jpg";
import pool4 from "../images/photoForSliders/waterpool/DSC05790.jpg";
import pool5 from "../images/photoForSliders/waterpool/DSC05794.jpg";
import pool6 from "../images/photoForSliders/waterpool/waterpoolImg.jpeg";
import rooms1 from "../images/photoForSliders/rooms/DSC05838.jpg";
import rooms2 from "../images/photoForSliders/rooms/DSC05839.jpg";
import rooms3 from "../images/photoForSliders/rooms/DSC06083.jpg";
import rooms4 from "../images/photoForSliders/rooms/DSC06087.jpg";
import rooms5 from "../images/photoForSliders/rooms/IMG_6244.jpg";
import RusSauna1 from "../images/photoForSliders/rusSauna/DSC05910.jpg";
import RusSauna2 from "../images/photoForSliders/rusSauna/фото-126.jpg";
import RusSauna3 from "../images/photoForSliders/rusSauna/фото-127.jpg";
import RusSauna4 from "../images/photoForSliders/rusSauna/фото-128 2.jpg";
import RusSauna5 from "../images/photoForSliders/rusSauna/фото-129.jpg";
import FinSauna1 from "../images/photoForSliders/finSauna/DSC06107.jpg";
import FinSauna2 from "../images/photoForSliders/finSauna/DSC06113.jpg";
import FinSauna3 from "../images/photoForSliders/finSauna/DSC06123.jpg";
import FinSauna4 from "../images/photoForSliders/finSauna/DSC06125.jpg";
import FinSauna5 from "../images/photoForSliders/finSauna/DSC06155.jpg";
import Hamam1 from "../images/photoForSliders/hamam/DSC06047.jpg";
import Hamam2 from "../images/photoForSliders/hamam/DSC06068.jpg";
import Hamam3 from "../images/photoForSliders/hamam/IMG_0829.jpg";
import Hamam4 from "../images/photoForSliders/hamam/IMG_1928-85.jpg";
import Hamam5 from "../images/photoForSliders/hamam/IMG_5911.jpg";
import twoHamam1 from "../images/photoForSliders/hamam2/DSC05897.jpg";
import twoHamam2 from "../images/photoForSliders/hamam2/DSC05902.jpg";
import twoHamam3 from "../images/photoForSliders/hamam2/DSC05917.jpg";
import twoHamam4 from "../images/photoForSliders/hamam2/фото-36.jpg";
import Sauna1 from "../images/photoForSliders/Sauna/DSC05944.jpg";
import Sauna2 from "../images/photoForSliders/Sauna/DSC05956.jpg";
import Sauna3 from "../images/photoForSliders/Sauna/DSC05964.jpg";
import Sauna4 from "../images/photoForSliders/Sauna/DSC05966.jpg";
import Sauna5 from "../images/photoForSliders/Sauna/DSC05979.jpg";
import SaunaTwo1 from "../images/photoForSliders/Sauna2/DSC05995.jpg";
import SaunaTwo2 from "../images/photoForSliders/Sauna2/DSC06008.jpg";
import SaunaTwo3 from "../images/photoForSliders/Sauna2/DSC06012.jpg";
import SaunaTwo4 from "../images/photoForSliders/Sauna2/DSC06023.jpg";
import SaunaTwo5 from "../images/photoForSliders/Sauna2/DSC06032.jpg";
import hall1 from "../images/photoForSliders/hall/hall1.jpeg";
import hall2 from "../images/photoForSliders/hall/hall2.jpeg";
import hall3 from "../images/photoForSliders/hall/hall3.jpeg";
import hall4 from "../images/photoForSliders/hall/hall4.jpeg";
import rusBath1 from "../images/photoForSliders/rusSauna2/rusbath1.jpeg";
import rusBath2 from "../images/photoForSliders/rusSauna2/rusbath2.jpeg";
import rusBath3 from "../images/photoForSliders/rusSauna2/rusbath3.jpeg";
import rusBath4 from "../images/photoForSliders/rusSauna2/rusbath4.jpeg";

export const Data = [
  {
    id: "waterpool",
    name: "Летний бассейн",
    descCard: "На территории базы отдыха находится:",
    titleLi:
      "— 25-метровый бассейн, вокруг которого так приятно расположиться;",
    titleLi2: "— 2 детских бассейна для маленьких гостей;",
    titleLi3: "— Теплый бассейн размером 4,5*5,5 с гидромассажем;",
    titleLi4: "— Бар с освежающими напитками;",
    titleLi5: "— Летнее кафе",
    titleLi6: "— Летние беседки",
    titleLi7: "— Зона барбекю",
    titleLi8: "— Комфортабельные домики",
    titleLi9: "— Шатры",
    titleLi10: "— Большой бассейн и маленький с панорамным стеклом",
    rightSection: "rightSectionWaterpool",

    classNameSection: "sectionPriceWaterpool",
    titleSectionPrice: "Летний бассейн",
    class: "rightSection_Title",
    titleList: "Выходные дни",
    li: "• Взрослые (с 10 лет): <span>500р</span>/час; <span>1700р</span>/день",
    li2: "• Дети (с 5 до 9 лет): <span>350р</span>/час; <span>900р</span>/день",
    titleList2: "Будние дни",
    li3: "• Взрослые (с 10 лет): <span></span>500р/час; <span>1500р</span>/день",
    li4: "• Дети (с 5 до 9 лет): <span></span>350р/час; <span>700р</span>/день",
    classFooter: "rightSection_footer",
    li5: "• Беседка малая <span>2500р</span>",
    li6: "• Беседка большая <span>3000р</span> ",
    li7: "• Шатер <span>2000р</span>",
    li8: "• Шатер Большой <span>12000р</span>",
    slide1: pool1,
    slide2: pool2,
    slide3: pool3,
    slide4: pool4,
    slide5: pool5,
    slide6: pool6,
  },
];

export const DataRooms = [
  {
    name: "Гостиничные номера",
    descCard:
      "Комфортабельные номера, которые подходят как для краткосрочного, так и для длительного проживания!",
    titleLi: "Во всех номерах к вашим услугам:\n",
    titleLi2: "• двуспальная кровать",
    titleLi3: "• отдельный санузел",
    titleLi7: "• бесплатный WI-FI",
    titleLi5: "• кондиционер",
    titleLi6: "• телевизор",
    rightSection: "rightSection",

    classNameSection: "sectionPrice",
    titleSectionPrice: "Гостиничные номера",

    li: "• <span>3000р-4500</span> - сутки\n",
    li2: "• <span>4500р</span> - Домик на летней территории\n",
    li3: "• <span>5000р</span> - Апартаменты\n",
  
    classFooter: "rightSection_footer",
    slide1: rooms3,
    slide2: rooms4,
    slide3: rooms5,
    slide4: rooms1,
    slide5: rooms2,
  },
];

export const DataRussianSauna = [
  {
    id: "rusSauna",
    name: "Русская баня на дровах №1",
    titleLi:
      "Территория включает в себя домик с русской баней, комнатой отдыха, верандой, мангальной зоной, открытым бассейном и Сибирским банным чаном.",
    titleLi2:
      "Отдых в русской бане избавит вас от усталости, укрепит дух, парение с помощью дров благоприятно скажется на нервной, дыхательной и сердечно-сосудистой системе.",
    titleLi3:
      "Парение с веником стимулирует кровообращение во всех слоях кожи и мышцах, помогает открытию кожных пор и вымыванию из них различных шлаков и микробов.",
    titleLi6:
      "Сибирский молодильный чан на открытом воздухе, с целебными травами, нагреваемый над костром избавит вас от стресса, уберет лишнее напряжение из мышц, ускорит обмен вещест в организме и укрепит вашу иммунную систему.",
    titleLi5:
      "Изюминкой похода в баню станет самоварное чаепитие! Вам будет предложен травяной чай, заваренный на костре.",
    rightSection: "rightSection",

    classNameSection: "sectionPrice",
    titleSectionPrice: "Русская баня на дровах",
    classOrange: "rightSection_Orange",
    OrangeText:
      "При посещении бани более чем на 5 часов, парение в Сибирском чане в подарок!",
    li: "• Русская баня <span>2800р</span>/ час",
    li2: "• Сибирский чан <span>3500р</span>",
    li3: "• Сутки (будние)<span>19000р</span>",
    li4: "• Выходные<span>22000р</span>",

    slide1: RusSauna2,
    slide2: RusSauna1,
    slide3: RusSauna3,
    slide4: RusSauna4,
    slide5: RusSauna5,
  },
];

export const DataRussianSauna2 = [
  {
    id: "rusSauna",
    name: "Русская баня на дровах №2",
    titleLi:
      "Территория включает в себя домик с русской баней, комнатами отдыха, верандой, мангальной зоной, открытым бассейном и Сибирским банным чаном.",
    titleLi2:
      "Отдых в русской бане — это не просто способ поддержания гигиеничности или расслабления, это целая культура, заслуживающая особого внимания.",
    titleLi3:
      "Таким образом, отдых в русской бане — это полноценный ритуал, который настраивает на здоровье, общение и гармонию.",
    titleLi6:
      "",
    titleLi5:
      "Это неотъемлемая часть русской культуры, уделяющая внимание не только физическому здоровью, но и душевному равновесию, и, без сомнения, стоит попробовать каждому, кто хочет ощутить на себе все прелести этого древнего искусства.",
    rightSection: "rightSection",

    classNameSection: "sectionPrice",
    titleSectionPrice: "Русская баня",
    classOrange: "rightSection_Orange",
    OrangeText:
      "При посещении бани более чем на 5 часов, парение в Сибирском чане в подарок!",
    
    li: "• Русская баня <span>2900р</span>/час",
    li2: "• Сутки <span>19000р</span>",
    li3: "• Пятница, суббота, воскресенье <span>23000р</span>",
    li4: "• До <span>15</span> человек входит в стоимость",

    slide1: rusBath1,
    slide2: rusBath2,
    slide3: rusBath3,
    slide4: rusBath4,
  },
];

export const FinshSauna = [
  {
    name: "Номер с финской парной и джакузи",
    titleLi:
      "Номер идеально подходит для отдыха вдвоем или комфортного расслабления в одиночестве!\n" +
      "К вашим услугам финская парная, аэрогидромассажная ванна, комната отдыха с просторной комфортабельной кроватью, а также зал отдыха.",
    titleLi2:
      "Баня по финской технологии-одна из самых жарких и сухих. Доступными словами-баня сухого жара.",
    titleLi3:
      "Сухой горячий воздух очищает верхние дыхательные пути, улучшает состояние слизистой, вентилирует легкие и это лишь малая часть полезных свойств данного вида парения.",
    titleLi5:
      "Аэрогидромассажная ванна- это оптимальное соотношение воздуха и воды. Джакузи станет настоящим спасением при сильной усталости и стрессе, прекрасно тонизирует кожу, расслабляет и успокаивает.",
    rightSection: "rightSection",

    classNameSection: "sectionPrice",
    titleSectionPrice: "Номер с финской парной и джакузи",
    li: "• цена рассчитана на 5 человек:  <span>1500р</span>/час\n",

    slide1: FinSauna1,
    slide2: FinSauna2,
    slide3: FinSauna3,
    slide4: FinSauna4,
    slide5: FinSauna5,
  },
];

export const DataHamam = [
  {
    name: "Хамам",
    titleLi:
      "Посещение хаммама- это возможность отдохнуть и доставить удовольствие своему телу.",
    titleLi2:
      "Уютная зона отдыха включает в себя несколько видов парных, а именно русская парная и турецкий хаммам, теплый бассейн размером 4,5*3 с гидромассажем,\n" +
      "зал с мраморным массажным столом.",
    titleLi3:
      "В зале отдыха установлен диван, стол из натурального дерева, массажное кресло, телевизор, музыкальный аппарат/караоке.",
    titleLi7:
      "В отличии от финской и русской бани, хаммам отличается более комфортным для человека тепловым режимом!\n" +
      "В турецкой парной влажный и мягкий пар,\n" +
      "при котором высокую температуру выдержать\n" +
      "не сложно( температура около 45 градусов).",
    titleLi5:
      "Тело погружается в пар полностью, при этом нормализуется кровообращение и терморегуляция,\n" +
      "а также расслабляются все мышцы. Для более сильного эффекта принято насыщать пар эфирными маслами.",
    rightSection: "rightSection",

    classNameSection: "sectionPrice",
    titleSectionPrice: "Хамам",
    li: "• цена рассчитана на 10 человек:\n" + "  <span>2900р</span>/час",
    li2: "• Если количество человек превышает вместимость зала, то дополнительное место оплачивается из расчета <span>200р</span>/час",

    slide1: Hamam1,
    slide2: Hamam2,
    slide3: Hamam3,
    slide4: Hamam4,
    slide5: Hamam5,
  },
];

export const DataHamamTwo = [
  {
    name: "Хамам 2",
    titleLi:
      "Общее оздоровление организма, расслабление и обретение спокойствия- вот за что высоко ценится турецкая баня.",
    titleLi2:
      "Главная особенность хамама- высокая влажность и температура 35-55 градусов.",
    titleLi3:
      "Благодаря этому, турецкая баня имеет минимальные противопоказания к посещению.",
    boldclass: "bold_title",
    BoldTitle: "К вашим услугам:\n",
    titleLi8: "• русская баня на дровах",
    titleLi5: "• турецкая баня (хамам)",
    titleLi6: "• бассейн с подогревом и водными атракционами",
    titleLi7: "• зал отдыха",
    rightSection: "rightSection",

    classNameSection: "sectionPrice",
    titleSectionPrice: "Хамам 2",
    li: "• <span>3200р</span>/час будние дни",
    li2: "• <span>3900р</span>/час выходные и праздничные дни",


    slide1: twoHamam1,
    slide2: twoHamam2,
    slide3: twoHamam3,
    slide4: twoHamam4,
  },
];

export const HallData = [
   {
    name: "Банкетный зал",
    titleLi:
      "Чарующий банкетный зал расположен на отдельной огороженной территории, идеально подходящий для празднования торжеств до 100 человек. Просторный интерьер сочетает стильный дизайн и комфорт, создавая атмосферу уюта. Большие окна наполняют зал естественным светом и открывают  панорамные виды",
    titleLi2:
      "Банкетный зал может быть легко адаптирован под любые форматы: свадьбы, юбилеи или корпоративы.",
    titleLi3:
      "На прилегающей территории располагается зеленая зона для выездных церемоний и фото-сессий. Удобная парковка добавляют комфорт в организации.",
    boldclass: "bold_title",
    BoldTitle: "Профессиональная команда наших партнеров“Family catering” обеспечит высокий уровень сервиса, предлагая разнообразное меню и индивидуальный подход к каждому событию.",
    titleLi8: " ",
    titleLi5: " ",
    titleLi6: " ",
    titleLi7: "",
    rightSection: "rightSection",

    classNameSection: "sectionPrice",
    titleSectionPrice: "Банкетный зал",
    li: "• Стоимость <span>70,000₽</span>",
    li2: " ",


    slide1: hall1,
    slide2: hall2,
    slide3: hall3,
    slide4: hall4,
  },
]

export const DataSauna = [
  {
    name: "Сауна №1",
    titleLi:
      "Идеальный выбор для отдыха компании друзей, уютного вечера в кругу близких, деловой встречи или для празднования дня рождения и других событий!",
    titleLi2:
      "Главная особенность хамама- высокая влажность и температура 35-55 градусов.",
    titleLi3:
      "Благодаря этому, турецкая баня имеет минимальные противопоказания к посещению.",
    boldclass: "bold_title",
    BoldTitle: "К вашим услугам 2 этажа:\n",
    titleLi7:
      "• На первом этаже расположен зал отдыха, оформленный в лучших русских традициях, массажное кресло, музыкальный аппарат/караоке, русская парная, небольшой бассейн с холодной водой.",
    titleLi5:
      "• На втором этаже расположен зал с бильярдным столом, что непременно оценят почитатели данной игры, а также для вашего удобства две полноценные комнаты отдыха.",
    rightSection: "rightSection",

    classNameSection: "sectionPrice",
    titleSectionPrice: "Сауна №1",
    li: "• цена рассчитана на 10 человек:\n" + "  <span>2200р</span>/час",
    li2: "• Если количество человек превышает вместимость зала, то дополнительное место оплачивается из расчета <span>200р</span>/час",

    slide1: Sauna1,
    slide2: Sauna2,
    slide3: Sauna3,
    slide4: Sauna4,
    slide5: Sauna5,
  },
];

export const DataSaunaTwo = [
  {
    name: "Сауна №2",
    titleLi:
      "К вашим услугам просторный зал, который подходит для отдыха компании до 10 человек, русская парная, подогреваемый бассейн размером 4,8*2,6 с гейзером, телевизор, музыкальный аппарат/караоке.",
    titleLi2:
      "Русская парная отличается особым легким влажным паром, который по вашему желанию можно дополнить ароматными целебными травами!",
    titleLi3:
      "Также за дополнительную плату к вашим услугам зал для игры в бильярд, полноценная комната отдыха.",
    rightSection: "rightSection",

    classNameSection: "sectionPrice",
    titleSectionPrice: "Сауна №2",
    li: "• цена рассчитана на 10 человек:\n" + "  <span>2500р</span>/час",
    li2: "• Если количество человек превышает вместимость зала, то дополнительное место оплачивается из расчета <span>200р</span>/час",
    li3: "• Бильярд  <span>200р</span>/ час",

    slide1: SaunaTwo1,
    slide2: SaunaTwo2,
    slide3: SaunaTwo3,
    slide4: SaunaTwo4,
    slide5: SaunaTwo5,
  },
];
